import React from 'react';
import {Link, useLocation} from "react-router-dom";
import {PRIVACY_ROUTE, PROFILE_ROUTE} from "../../util/Constants";

const ShipmentForm = ({
    shipment,
    setShipment,
    save,
    errors,
    saveDisabled,
    /** На странице оформления заказа: подсветка полей после попытки отправки */
    attemptedSubmit = false,
    /** Вместо поля «Адрес» (оформление заказа с Яндекс-ПВЗ) */
    pickupSlot = null,
    /** Подсказка при наведении, если кнопка неактивна (например, ждём расчёт доставки) */
    saveButtonTitle = '',
}) => {
    const location = useLocation()
    const isProfile = location.pathname === PROFILE_ROUTE
    const err = !!errors
    const mark = (bad) => (err || attemptedSubmit) && bad

    return (
        <div className="lut-card flex flex-col gap-4">
            <h2 className="text-lg font-semibold text-bark-900">Информация для доставки</h2>
            <div className="flex flex-col gap-4">
                <div>
                    <label className="lut-label">ФИО</label>
                    <input
                        className={`lut-input ${mark(!shipment.name?.trim()) ? 'lut-input-error' : ''}`}
                        value={shipment.name}
                        onChange={e => setShipment({...shipment, name: e.target.value})}
                    />
                </div>
                {pickupSlot ? (
                    <div className="flex flex-col gap-2">
                        <label className="lut-label">Пункт выдачи</label>
                        {pickupSlot}
                    </div>
                ) : (
                    <div>
                        <label className="lut-label">Адрес</label>
                        <input
                            className={`lut-input ${mark(!shipment.address?.trim()) ? 'lut-input-error' : ''}`}
                            value={shipment.address}
                            onChange={(e) => setShipment({...shipment, address: e.target.value})}
                        />
                    </div>
                )}
                <div>
                    <label className="lut-label">Телефон{!isProfile ? ' *' : ''}</label>
                    <input
                        className={`lut-input ${mark(!shipment.phone?.trim()) ? 'lut-input-error' : ''}`}
                        value={shipment.phone}
                        onChange={e => setShipment({...shipment, phone: e.target.value})}
                        inputMode="tel"
                        autoComplete="tel"
                    />
                </div>
                <div>
                    <label className="lut-label">Email</label>
                    <input
                        className={`lut-input ${mark(!shipment.email?.trim()) ? 'lut-input-error' : ''}`}
                        type="email"
                        value={shipment.email}
                        onChange={e => setShipment({...shipment, email: e.target.value})}
                    />
                </div>
                {!isProfile && (
                    <div>
                        <label className="lut-label">Комментарий к заказу</label>
                        <textarea
                            className="lut-input min-h-[100px] resize-y"
                            value={shipment.commentary || ''}
                            onChange={e => setShipment({...shipment, commentary: e.target.value})}
                        />
                    </div>
                )}
                <p className="text-xs text-bark-500">
                    Нажимая кнопку, вы соглашаетесь на{' '}
                    <Link
                        to={PRIVACY_ROUTE}
                        className="font-medium text-pine-800 underline decoration-pine-400/60 underline-offset-2 hover:text-pine-900"
                    >
                        обработку персональных данных
                    </Link>
                    .
                </p>
                <span
                    className="inline-flex w-full sm:w-auto"
                    title={
                        saveDisabled && saveButtonTitle
                            ? saveButtonTitle
                            : undefined
                    }
                >
                    <button
                        type="button"
                        onClick={save}
                        disabled={!!saveDisabled}
                        className="lut-btn-pine w-full touch-manipulation disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto"
                    >
                        {isProfile ? 'Сохранить' : 'Оформить заказ'}
                    </button>
                </span>
                {err && typeof errors === 'string' && (
                    <p className="text-sm text-red-600">{errors}</p>
                )}
            </div>
        </div>
    );
};

export default ShipmentForm;
